// extracted by mini-css-extract-plugin
export var connectionButton = "_9t-1";
export var rightPanel = "_9t-3";
export var stepDescription = "_9t-2";
export var stepIcon = "_9t-0";